const BACKEND_URL = process.env.VUE_APP_LANDING_PAGE_BACKEND_URL;
const BLOG_BACKEND_URL = "https://api.lumitus.com.vn";

export default {
  BACKEND_URL: BACKEND_URL,
  LANDING_PAGE_AUTH: `${BACKEND_URL}/admin/auth`,

  // ENDPOINT for home 
  HOME_BANNER: `${BACKEND_URL}/admin/banner-page`,
  HOME_SERVICE: `${BACKEND_URL}/admin/service`,
  HOME_PROCESS: `${BACKEND_URL}/admin/process`,
  HOME_TECHNOLOGY: `${BACKEND_URL}/admin/technology`,
  HOME_PARTNER: `${BACKEND_URL}/admin/partner`,
  HOME_QUESTION: `${BACKEND_URL}/admin/question`,
  HOME_REVIEW: `${BACKEND_URL}/admin/customer-review`,
  HOME_REGISTER_CONSULTATION: `${BACKEND_URL}/admin/register-for-consultation`,
  HOME_PRODUCT_SERIVICE_TRYING: `${BACKEND_URL}/admin/product-service`,
  HOME_FIELD_PROJECT: `${BACKEND_URL}/admin/field-project`,

  // ENDPOINT for news
  NEWS: `${BACKEND_URL}/admin/news`,

  // ENDPOINT for package
  PACKAGE: `${BACKEND_URL}/admin/package`,

  // ENDPOINT for project
  PROJECT: `${BACKEND_URL}/admin/project`,

  // ENDPOINT for career
  RECRUIMENT: `${BACKEND_URL}/admin/recruitment`,
  CAREER: `${BACKEND_URL}/admin/career`,
  CAREER_CATEGORY: `${BACKEND_URL}/admin/career-category`,
  RECRUIMENT_PROCESS: `${BACKEND_URL}/admin/recruitment-process`,
  DELETE_INTRODUCE_FILE: `${BACKEND_URL}/admin/recruitment-delete-file`,

  // ENDPOINT for about us
  ABOUT_US: `${BACKEND_URL}/admin/about-us`,
  ABOUT_US_DELETE_FILE: `${BACKEND_URL}/admin/about-us-delete-file`,

  // ENDPOINT for contact
  QUESTION_ANSWER: `${BACKEND_URL}/admin/question-answer`,
  CONSULTATION_FORM_ADMIN: `${BACKEND_URL}/admin/consultation-form-admin`,

  // ENDPOINT for news
  CATEGORY: `${BACKEND_URL}/admin/category`,
  ARTICLE: `${BACKEND_URL}/admin/article`,
 
  // USER MANAGEMENT
  USER_MANAGEMENT: `${BACKEND_URL}/admin/users`,

  // COMMENT MANAGEMENT
  COMMENT_MANAGEMENT: `${BACKEND_URL}/admin/comments`,

  // Other
  UPLOAD: `${BACKEND_URL}/admin/upload`,

  // Blog endpoint
  BLOG_BACKEND_URL: BLOG_BACKEND_URL,
  BLOG_AUTH: `${BLOG_BACKEND_URL}/admin/auth`,
  BLOG_CATEGORIES: `${BLOG_BACKEND_URL}/admin/categories`,
  BLOG_SEARCH_CATEGORY: `${BLOG_BACKEND_URL}/admin/categories/search`,
  BLOG_POSTS: `${BLOG_BACKEND_URL}/admin/posts`,
  BLOG_SEARCH_POSTS: `${BLOG_BACKEND_URL}/admin/posts/search`,
  BLOG_UPLOAD: `${BLOG_BACKEND_URL}/admin/upload`,
  BLOG_FEEDBACK: `${BLOG_BACKEND_URL}/admin/feedback`,

  BLOG_ADVISE: `${BLOG_BACKEND_URL}/admin/need-advise`,
  BLOG_SUBSCRIBE: `${BLOG_BACKEND_URL}/admin/subscribe`,
  BLOG_BANNER: `${BLOG_BACKEND_URL}/admin/banner`,
  BLOG_BANNER_PAGE: `${BLOG_BACKEND_URL}/admin/banner-page`,
  BLOG_PODCAST: `${BLOG_BACKEND_URL}/admin/podcast`,
};
